import React, { Component } from 'react';
import {
  Badge,
  Button,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  InputGroup,
  InputGroupButton,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  PaginationItem,
  PaginationLink,
  Row,
  Table
} from 'reactstrap';
import Pagination from '../../components/Pagination';

// Firebase
import { app } from '../../base';

const TableRow = (props) => {
  var status = parseInt(props.data.status) && 1;
  return (
    <tr>
      <td>{props.data.city || ''}</td>
      <td>{props.data.province || ''}</td>
      <td>{props.data.neighborhood || ''}</td>
      <td>{props.data.street || ''}</td>
      <td>{props.data.area_code || ''}</td>
      <td align="center">
        <i className="fa fa-pencil fa-lg mr-1 icon-pointer" onClick={()=>props.viewForm(props.rowKey, props.data)}></i>
        <i className="fa fa-remove fa-lg icon-pointer" onClick={()=>props.deleteData(props.rowKey)}></i>
      </td>
    </tr>
  );
}

function ShowMessage(props) {
  return <div className="alert alert-info" role="alert" style={{display:props.show}}>{props.message}</div>;
}

class Locations extends Component {
  constructor() {
    super();
    var data = {
      city: '',
      province: '',
      neighborhood: '',
      street: '',
      area_code: ''
    };

    this.state = {
      data: data,
      modal: false,
      rows: [],
      pageOfItems: [],
      searchRows: [],
      show: 'none'
    };
    this.onChangePage = this.onChangePage.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.viewForm = this.viewForm.bind(this);
  }

  componentWillMount() {
    app.database().ref('/locations').on('value', (snapshot) => {
      var items = snapshot.val();
      var rows = [];
      for (var key in items) {
        rows.push(<TableRow key={key} data={items[key]} rowKey={key} viewForm={this.viewForm} deleteData={this.deleteData} />);
      }
      this.setState({
        rows:rows,
        searchRows: rows
      });
    });
  }

  deleteData(key) {
    if (confirm("Are you sure you want to delete this item?")) {
      app.database().ref('locations/' + key).remove()
      .catch((error)=>{
        alert(error.message);
      });
    }
  }

  filterData(searchText, element){
    searchText = searchText.toLowerCase();
    return (element.props.data.city.toLowerCase().indexOf(searchText) != -1) ||
            (element.props.data.province.toLowerCase().indexOf(searchText) != -1) ||
            (element.props.data.neighborhood.toLowerCase().indexOf(searchText) != -1) ||
            (element.props.data.street.toLowerCase().indexOf(searchText) != -1) ||
            (element.props.data.area_code.toLowerCase().indexOf(searchText) != -1)
  }

  onChangePage(pageOfItems) {
    // update state with new page of items
    this.setState({ pageOfItems: pageOfItems });
  }

  onSearch(event) {
    event.preventDefault()

    const searchText = this.searchInput.value

    if (this.state.searchRows.length == 0) return;

    let rows = this.state.searchRows.filter(this.filterData.bind(this, searchText));
    this.setState({rows:rows});
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
              {/*
                <Col md="4">
                  <FormGroup>
                    <form onSubmit={(event) => { this.onSearch(event) }} ref={(form) => { this.searchForm = form }}>
                      <InputGroup>
                        <Input size="10" type="text" placeholder="Enter text here" innerRef={(input) => { this.searchInput = input }}/>
                        <InputGroupButton>
                          <Button color="info">Search</Button>
                        </InputGroupButton>
                      </InputGroup>
                    </form>
                  </FormGroup>
                </Col>
              */}
                <Table bordered striped responsive size="sm">
                  <thead>
                  <tr>
                    <th>City</th>
                    <th>Province</th>
                    <th>Neighborhood</th>
                    <th>Street</th>
                    <th>Area Code</th>
                    <th className="text-center">Action</th>
                  </tr>
                  </thead>
                  <tbody>{this.state.pageOfItems}</tbody>
                </Table>
                <nav>
                  <Pagination items={this.state.rows} onChangePage={this.onChangePage} />
                </nav>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} className='modal-lg'>
                  <form onSubmit={(event) => { this.updateData(event) }} ref={(form) => { this.editForm = form }}>
                  <ModalHeader toggle={this.toggleModal}>
                    <ShowMessage show={this.state.show} message={this.state.message} />
                  </ModalHeader>
                  <ModalBody>
                      <InputGroup className="mb-3">
                        <Input type="text" placeholder="City" innerRef={(input) => { this.cityInput = input }} defaultValue={this.state.data.city} />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <Input type="text" placeholder="Province" innerRef={(input) => { this.provinceInput = input }} defaultValue={this.state.data.province} />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <Input type="text" placeholder="Neighborhood" innerRef={(input) => { this.neighborhoodInput = input }} defaultValue={this.state.data.neighborhood} />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <Input type="text" placeholder="Street" innerRef={(input) => { this.streetInput = input }} defaultValue={this.state.data.street} />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <Input type="text" placeholder="Area Code" innerRef={(input) => { this.areaCodeInput = input }} defaultValue={this.state.data.area_code} />
                      </InputGroup>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary">Update</Button>{' '}
                    <Button color="secondary" onClick={this.toggleModal}>Cancel</Button>
                  </ModalFooter>
                  </form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }

  setMessage(msg) {
    this.setState({
      message: msg,
      show: ''
    });
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }

  updateData(event) {
    event.preventDefault()
    const city = this.cityInput.value
    const province = this.provinceInput.value
    const neighborhood = this.neighborhoodInput.value
    const street = this.streetInput.value
    const areaCode = this.areaCodeInput.value
    //console.log(city+"-"+province+"-"+neighborhood+"-"+street+"-"+areaCode)

    if (city == '' || province == '' || neighborhood == '' || street == '' || areaCode == '') {
      this.setMessage('All fields must be filled');
      return;
    }
    
    app.database().ref('locations/' + this.state.key).update({
      area_code: areaCode.toUpperCase(),
      city: city.toUpperCase(),
      neighborhood: neighborhood.toUpperCase(),
      province: province.toUpperCase(),
      street: street.toUpperCase()
    }).then(()=>{
      this.setState({
        modal: !this.state.modal
      });
    }).catch((error)=>{
      this.setMessage(error.message);
    });
  }

  viewForm(key, data) {
    this.setState({
      data: data,
      key: key,
      modal: !this.state.modal
    });
  }
}

export default Locations;


// WEBPACK FOOTER //
// ./src/views/Locations/Locations.js